(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdc-lander"] && !Shopify.designMode) return;
  try {
    
/* ---- reviews (20, paginated 3-at-a-time) ---- */
  var REVIEWS=[
    {n:"Wendy R.",r:5,t:"She sleeps through the whole night now",b:"On the first night I didn't hear a single lick. Three weeks in and the 3am scratching that woke the whole house is just… gone. She's a calmer little dog.",dog:"Maltese · 8 lbs",res:"Calmer by week 3",photo:"https://cdn.shopify.com/s/files/1/1064/7728/9813/files/rev-wendy.png"},
    {n:"Ronald P.",r:5,t:"Happy dog, happy dog dad",b:"He doesn't chew his paws or scratch at his ears the way he used to. I didn't expect a chew to do what the vet's creams couldn't. Happy dog, happy dog dad.",dog:"French Bulldog · 22 lbs",res:"Results by week 4",photo:"https://cdn.shopify.com/s/files/1/1064/7728/9813/files/rev-ronald.png"},
    {n:"Rhonda M.",r:5,t:"Her paws aren't rust-stained anymore",b:"Her white paws had turned brown from constant licking. A month on this and the staining is fading because she's finally left them alone. Wish I'd found it sooner.",dog:"Yorkie · 6 lbs",res:"Results by week 5",photo:"https://cdn.shopify.com/s/files/1/1064/7728/9813/files/rev-rhonda.png"},
    {n:"George T.",r:5,t:"Finally something sized for a little guy",b:"For years I cut big-dog chews into quarters and hoped. One chew, his exact size, no knife, no guessing. And the itching is way down. This is how it should've always been.",dog:"Dachshund · 14 lbs",res:"Results by week 6",photo:"https://cdn.shopify.com/s/files/1/1064/7728/9813/files/rev-george.png"},
    {n:"Mia K.",r:5,t:"No more corn-chip ears",b:"That yeasty smell from her ears that came back after every cleaning? Gone. She's not shaking her head at night anymore and her coat looks shinier too.",dog:"Pomeranian · 5 lbs",res:"Calmer by week 3",photo:"https://cdn.shopify.com/s/files/1/1064/7728/9813/files/rev-mia.png"},
    {n:"Danielle S.",r:5,t:"The 3am scratching stopped",b:"The collar jingle at 3am was our alarm clock for two years. It's quiet now. I almost cried the first full night we both slept.",dog:"Shih Tzu · 12 lbs",res:"Results by week 4",ini:"DS",c:"#3a5a8c"},
    {n:"Marcus B.",r:5,t:"He actually begs for it",b:"My chihuahua is the pickiest eater alive and he runs to the kitchen for this. That alone was worth it — then the paw-licking calmed down on top of it.",dog:"Chihuahua · 4 lbs",res:"Results by week 5",ini:"MB",c:"#c88710"},
    {n:"Priya N.",r:5,t:"Off the itch cycle for the first time",b:"We'd been on the shampoo-wipe-pill merry-go-round forever. This is the first thing that worked at the root instead of covering it up. She's a different dog.",dog:"Maltipoo · 9 lbs",res:"Results by week 4",ini:"PN",c:"#4a7c59"},
    {n:"Kevin O.",r:4,t:"Took a few weeks, but it worked",b:"Not an overnight miracle — around week three I noticed he'd stopped the constant scratching. Glad I gave it the full time. Honest product.",dog:"French Bulldog · 24 lbs",res:"Results by week 3",ini:"KO",c:"#7a5c9e"},
    {n:"Sarah W.",r:5,t:"No more cutting pills into quarters",b:"The best part is how simple it is. One chew, her size, done. She used to spit out the halved pills — this she treats like a snack.",dog:"Yorkie · 5 lbs",res:"Results by week 5",ini:"SW",c:"#b5654a"},
    {n:"Tom R.",r:5,t:"His red belly finally calmed down",b:"The angry pink belly and the hot spots have settled right down. He's not flinching when I rub his tummy anymore. Huge difference for a little dog.",dog:"Boston Terrier · 16 lbs",res:"Results by week 6",ini:"TR",c:"#2f6f8f"},
    {n:"Ana G.",r:5,t:"She stopped licking her paws raw",b:"She'd lick until they were raw and sore. Two weeks in the licking eased and now they've healed. I didn't think a gut supplement would fix her paws, but here we are.",dog:"Chihuahua mix · 7 lbs",res:"Results by week 4",ini:"AG",c:"#8a5a2b"},
    {n:"Jessica L.",r:5,t:"Shinier coat, calmer dog",b:"Bonus I didn't expect: her coat is softer and shinier, not just less itchy. She seems calmer overall, like she's finally comfortable in her own skin.",dog:"Pomeranian · 6 lbs",res:"Results by week 5",ini:"JL",c:"#3a5a8c"},
    {n:"Brian K.",r:4,t:"Wish it were instant — but it's real",b:"I'm impatient, so the honest timeline frustrated me at first. But by week four the difference was undeniable and it's held since. Worth the wait.",dog:"Pug · 18 lbs",res:"Results by week 4",ini:"BK",c:"#6a6f4a"},
    {n:"Nicole T.",r:5,t:"Even the picky one eats it",b:"My toy poodle turns her nose up at everything. She devours this. And the scratching that drove us both crazy has genuinely calmed down.",dog:"Toy Poodle · 8 lbs",res:"Calmer by week 3",ini:"NT",c:"#a4453f"},
    {n:"David M.",r:5,t:"Saved us the monthly vet trips",b:"We were at the vet almost monthly for his ears and skin. Since starting this we haven't been back for the itch. It's paid for itself several times over.",dog:"Shih Tzu · 13 lbs",res:"Results by week 6",ini:"DM",c:"#2f6f8f"},
    {n:"Emily C.",r:5,t:"One chew, no math",b:"I love that I don't have to calculate a dose by weight. One chew covers my little one. Simple, and the itching has really settled down.",dog:"Maltese · 6 lbs",res:"Results by week 5",ini:"EC",c:"#7a5c9e"},
    {n:"Robert H.",r:5,t:"From constant scratching to rare",b:"He went from scratching all day to the odd scratch here and there. For a dog who never sat still, seeing him just relax on the couch is everything.",dog:"Dachshund · 15 lbs",res:"Results by week 4",ini:"RH",c:"#4a7c59"},
    {n:"Laura P.",r:5,t:"My little one finally has peace",b:"She was miserable every pollen season. This is the first spring she's been comfortable. No raw paws, no whining at night. Thank you for making something for the small ones.",dog:"Yorkie · 4 lbs",res:"Results by week 5",ini:"LP",c:"#b5654a"},
    {n:"Chris D.",r:5,t:"Better than the shots we were on",b:"We were doing the monthly shots and the cost was brutal. This calmed his skin without the needle and without the price tag. I only wish we'd tried it first.",dog:"French Bulldog · 23 lbs",res:"Results by week 6",ini:"CD",c:"#c88710"},
    {n:"Hannah B.",r:5,t:"The whole house sleeps again",b:"When she stopped scratching, we all started sleeping. Such a small change that fixed everything. She's playful and happy in a way I hadn't seen in years.",dog:"Maltese · 7 lbs",res:"Calmer by week 3",ini:"HB",c:"#3a5a8c"}
  ];
  function starRow(n){var s="";for(var i=1;i<=5;i++){s+="<span"+(i<=n?"":" class='off'")+">★</span>";}return s;}
  function avatar(r){return r.photo?"<img class='rvav' src='"+r.photo+"' alt='"+r.n+"'>":"<div class='rvav' style='background:"+r.c+"'>"+r.ini+"</div>";}
  function card(r){return "<div class='rvcard'><div class='rvtop'><span class='stars'>"+starRow(r.r)+"</span><span class='vchip'>Verified Buyer</span></div>"+
    "<div class='rvtitle'>"+r.t+"</div><p class='rvbody'>"+r.b+"</p>"+
    "<div class='rvfoot'>"+avatar(r)+"<div class='rvwho'><div class='rvname'>"+r.n+"</div><div class='rvmeta'>"+r.dog+" · "+r.res+"</div></div></div></div>";}
  function mountReviews(gridId,order){
    var grid=document.getElementById(gridId);if(!grid)return;
    var btn=document.querySelector(".rvbtn[data-target='"+gridId+"']");
    var shown=0,step=3;
    function render(){var next=Math.min(shown+step,order.length),h="";for(var i=shown;i<next;i++){h+=card(order[i]);}grid.insertAdjacentHTML("beforeend",h);shown=next;if(btn&&shown>=order.length)btn.hidden=true;}
    render();if(btn)btn.addEventListener("click",render);
  }
  mountReviews("rvgrid-main",REVIEWS);
  mountReviews("rvgrid-bottom",REVIEWS.slice(10).concat(REVIEWS.slice(0,10)));
  /* ---- stories carousel: clone slides once for a seamless loop ---- */
  (function(){var tr=document.getElementById("scartrack");if(!tr)return;var kids=Array.prototype.slice.call(tr.children);kids.forEach(function(k){tr.appendChild(k.cloneNode(true));});})();
  /* ---- offer: quantity select + gift unlock ---- */
  (function(){
    var cards=document.querySelectorAll(".qcard");
    var ulks=document.querySelectorAll(".unlocks .ulk");
    var onetime=document.querySelector(".onetime-link");
    if(!cards.length)return;
    function select(tier){
      cards.forEach(function(c){c.classList.toggle("selected",c.getAttribute("data-tier")===String(tier));});
      ulks.forEach(function(u){var on=parseInt(u.getAttribute("data-min"),10)<=tier;u.classList.toggle("on",on);u.classList.toggle("off",!on);});
      if(onetime)onetime.classList.toggle("selected",tier===0);
    }
    cards.forEach(function(c){c.addEventListener("click",function(){select(parseInt(c.getAttribute("data-tier"),10));});});
    if(onetime)onetime.addEventListener("click",function(){select(0);});
    select(3); // default: best value (all gifts unlocked)
    document.querySelectorAll("[data-selectbest]").forEach(function(a){a.addEventListener("click",function(){select(3);});});
  })();
  /* ---- buy-box gallery: thumbnail swap + swipe ---- */
  (function(){
    var thumbs=document.querySelectorAll(".gthumb");
    var slides=document.querySelectorAll(".gslide");
    var main=document.querySelector(".gmain");
    if(!thumbs.length||!slides.length)return;
    var count=slides.length, cur=0;
    function goTo(i){
      if(i<0)i=count-1; if(i>=count)i=0; cur=i;
      thumbs.forEach(function(x){x.classList.toggle("active",x.getAttribute("data-go")===String(i));});
      slides.forEach(function(s){s.classList.toggle("active",s.getAttribute("data-slide")===String(i));});
    }
    thumbs.forEach(function(t){t.addEventListener("click",function(){goTo(parseInt(t.getAttribute("data-go"),10));});});
    if(main){
      var x0=null,y0=null;
      main.addEventListener("touchstart",function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});
      main.addEventListener("touchend",function(e){
        if(x0===null)return;var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;
        if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))goTo(cur+(dx<0?1:-1));x0=null;
      },{passive:true});
      main.addEventListener("mousedown",function(e){x0=e.clientX;});
      main.addEventListener("mouseup",function(e){if(x0===null)return;var dx=e.clientX-x0;if(Math.abs(dx)>40)goTo(cur+(dx<0?1:-1));x0=null;});
      main.style.touchAction="pan-y";main.style.cursor="grab";
    }
  })();

  function tick(){
    var now=new Date(), end=new Date(now); end.setHours(24,0,0,0);
    var t=Math.max(0,(end-now)/1000|0);
    var h=t/3600|0, m=(t%3600)/60|0, s=t%60;
    var p=function(n){return (n<10?"0":"")+n};
    document.getElementById("d").textContent=0;
    document.getElementById("h").textContent=p(h);
    document.getElementById("m").textContent=p(m);
    document.getElementById("s").textContent=p(s);
    document.getElementById("s2").textContent=p(h)+":"+p(m)+":"+p(s);
  }
  tick(); setInterval(tick,1000);


/* ---- SmallDogCO direct-to-checkout ---- */
(function(){
  var SDC = { variant: "54407581860181", plans: { "1": "691323732309", "3": "691323765077" } }; // Loop selling plan IDs
  window.SDC = SDC;
  function selectedTier(){
    var s=document.querySelector('.qcard.selected'); if(s) return s.getAttribute('data-tier');
    var o=document.querySelector('.onetime-link.selected'); if(o) return "0";
    return "3";
  }
  async function buyNow(){
    var tier=selectedTier();
    var plan = (tier==="0") ? null : SDC.plans[tier];
    try{
      await fetch('/cart/clear.js',{method:'POST'});
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(SDC.variant),quantity:1,selling_plan:plan||undefined}]})});
    }catch(e){}
    window.location.href='/checkout';
  }
  window.sdcBuyNow=buyNow;
  document.addEventListener('click',function(e){
    var t=e.target.closest('.cta.block, [data-buynow]');
    if(t){ e.preventDefault(); buyNow(); }
  });
  /* In-page anchors (#buy from the sticky bar and every section CTA) must scroll to the target,
     never fire buyNow. The base theme scrolls inside .page-wrapper (overflow:auto), so the native
     fragment jump never moves the page; behavior:'instant' beats its global scroll-behavior:smooth,
     which drifts off target while lazy media loads. */
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href^="#"]'); if(!a)return;
    if(a.closest('.cta.block, [data-buynow]'))return;            // those go to checkout on purpose
    var sel=a.getAttribute('href'); if(!sel||sel.length<2)return;
    var tgt; try{tgt=document.querySelector(sel);}catch(err){return;}
    if(!tgt)return;
    e.preventDefault();
    var go=function(){var t=document.querySelector(sel); if(t)t.scrollIntoView({behavior:'instant',block:'start'});};
    go(); setTimeout(go,350); setTimeout(go,900);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
